<div
  class="expansion-element flex flex-col w-full rounded-md loading relative border overflow-hidden"
  data-test-id="expansion-element"
  @parentAnimation
  [ngClass]="{
    'hover:border-navy-90 hover:shadow-sm': hoverable,
    'border-navy-90 shadow-sm': focused,
    'bg-navy-10': backgroundType === 'dark',
    'bg-white': backgroundType === 'light',
    'shadow-sm': shadow,
    'pointer-events-none opacity-70': disabled,
    'border-navy-40': headerType === 'compact',
    'border-navy-50': headerType === 'normal',
  }"
>
  <div
    class="item-header flex items-center px-5 w-full"
    [ngClass]="{
      'cursor-pointer': hasCursorPointer,
      'cursor-default': !hasCursorPointer,
      'h-12': headerType === 'compact',
      'h-15': headerType === 'normal',
    }"
    (click)="handleHeaderClick($event)"
  >
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
  </div>

  @if (expanded) {
    <div class="item-body overflow-hidden" @expandCollapse (@expandCollapse.done)="animationDone()">
      <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
    </div>
  }
</div>
